import React from "react";

import classNames from "classnames";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { observer } from "mobx-react";

import { VerticalSeparator } from "../../settingsForms/separators/verticalSeparator/verticalSeparator";
import { ElementFormActions } from "../../settingsForms/elementForm/actions/elementFormActions";
import { ElementFormEditIcon } from "../../settingsForms/elementForm/icons/elementFormEditIcon";

import settingStyles from "../../../../styles/settings.css";
import styles from "../styles.css";
import { ElementForm } from "../../settingsForms/elementForm/elementForm/elementForm";
import { TranslationString } from "../types";
import { AppPresence } from "@closerplatform/spinner-openapi";

interface Props {
  status: AppPresence;
  onEdit?: () => void;
}

export const StatusBox = observer(({ status, onEdit }: Props) => {
  const shouldShowMenu = !!onEdit;

  return (
    <ElementForm>
      <div className={classNames(styles["form-element"], styles["no-grow"])}>
        <span className={classNames(settingStyles["form-label-font"])}>
          {intl.formatMessage("settings.adviserStatuses.status.name")}
        </span>
        <p
          className={classNames(
            settingStyles["form-content-font"],
            styles.value,
            styles["status-name"]
          )}
        >
          {intl.formatMessage(`presenceStatus.${status}` as TranslationString)}
        </p>
      </div>
      <VerticalSeparator />
      <div className={classNames(styles["form-element"])}>
        <span className={classNames(settingStyles["form-label-font"])}>
          {intl.formatMessage("settings.adviserStatuses.status.description")}
        </span>
        <p className={classNames(settingStyles["form-content-font"], styles.value)}>
          {intl.formatMessage(`presenceStatus.${status}.description` as TranslationString)}
        </p>
      </div>
      {shouldShowMenu && (
        <>
          <VerticalSeparator />
          <ElementFormActions>
            {onEdit && <ElementFormEditIcon onClick={onEdit} />}
          </ElementFormActions>
        </>
      )}
    </ElementForm>
  );
});
